import { Grid } from '@mui/material';
import { ICandidateExperience } from 'wisestep-api';
import { Label, WsDatePicker } from 'wisestep-base';

import CollapsibleBox from '../CollapsibleBox';
import { EditTextWithLabel } from '../UpdateCandidateDetailsCard';

export interface Experience extends ICandidateExperience {
  expanded?: boolean;
  isAdd?: boolean;
  isPrimary?: boolean;
}

const ExperienceData = ({
  experience,
  index,
  formatDateRange,
  onDelete,
  onConfirm,
}: {
  experience: Experience;
  index?: number;
  formatDateRange: (start: any, end: any) => void;
  onDelete?: () => void;
  onConfirm?: () => void;
}) => {
  const organization = experience.isPrimary
    ? 'experience.current.org'
    : `experience.history[${index}].org`;
  const title = experience.isPrimary
    ? 'experience.current.title'
    : `experience.history[${index}].title`;

  const startDate = experience.isPrimary
    ? 'experience.current.startDate'
    : `experience.history[${index}].startDate`;
  const endDate = experience.isPrimary
    ? 'experience.current.endDate'
    : `experience.history[${index}].endDate`;

  return (
    <Grid key={index} style={{ display: 'flex', alignItems: 'center', marginTop: 4 }}>
      <CollapsibleBox
        department={experience.title}
        institutionValue={experience.org}
        gradScore={''}
        date={formatDateRange(experience.startDate, experience.endDate)}
        expanded={experience.expanded}
        onDelete={onDelete}
        onConfirm={onConfirm}
        isAdd={experience.isAdd}
        hideDelete={experience.isPrimary}
      >
        <EditTextWithLabel
          name={organization}
          labelText="Organization"
          type="text"
          required={true}
        />
        <EditTextWithLabel name={title} labelText="Role" type="text" />
        <Grid item xs={8}>
          <Label>{'Start Date'}</Label>
          <WsDatePicker
            name={startDate}
            label="startDate"
            disableFuture={true}
            disabled={false}
            required={false}
          />
        </Grid>
        <Grid item xs={8}>
          <Label>{'End Date'}</Label>
          <WsDatePicker
            name={endDate}
            label="endDate"
            disableFuture={true}
            disabled={false}
            required={false}
          />
        </Grid>
      </CollapsibleBox>
    </Grid>
  );
};
export default ExperienceData;
